import Page from '@/services/Page'

interface WebKitMessageHandler {
  postMessage: (message: string) => void
}

interface NativeBridgeWindow {
  Android?: {
    onStoreSelected?: (params: string) => void
  }
  webkit?: {
    messageHandlers?: {
      onStoreSelected?: WebKitMessageHandler
    }
  }
}

interface StorePayload {
  id: string
  name: string
  latitude: number
  longitude: number
  address: string
}

/**
 * アプリへ送信する店舗情報を生成する
 *
 * @param point 選択された店舗
 * @returns アプリ連携用の店舗情報
 */
export function createStorePayload(point: Point): StorePayload {
  return {
    id: point.key,
    name: point.name,
    latitude: point.latitude,
    longitude: point.longitude,
    address: point.address,
  }
}

/**
 * AndroidまたはiOSのJSブリッジへ店舗情報を送信する
 *
 * @param point 選択された店舗
 * @returns JSブリッジを呼び出した場合はtrue
 */
export function sendStoreToNative(point: Point): boolean {
  const json = JSON.stringify(createStorePayload(point))
  const nativeWindow = window as unknown as NativeBridgeWindow

  if (typeof nativeWindow.Android?.onStoreSelected === 'function') {
    nativeWindow.Android.onStoreSelected(json)
    return true
  }

  const iosHandler = nativeWindow.webkit?.messageHandlers?.onStoreSelected
  if (typeof iosHandler?.postMessage === 'function') {
    iosHandler.postMessage(json)
    return true
  }

  console.error('onStoreSelected JS bridge is not available')
  return false
}

/**
 * Google Mapで表示ボタンの押下を処理する
 *
 * iframeパラメータ付きの場合はアプリへ店舗情報を送り、
 * 通常表示の場合はGoogle Mapsを別タブで開く
 *
 * @param point 選択された店舗
 */
export function handleOpenGoogleMap(point: Point): void {
  const isIframe = Object.prototype.hasOwnProperty.call(
    storelocator.url_params || {},
    'iframe',
  )

  if (isIframe) {
    sendStoreToNative(point)
    return
  }

  const googleMapsUrl = Page.getGoogleMapsLink(
    null,
    null,
    `${point.address} ${point.name}`,
  )
  window.open(googleMapsUrl, '_blank', 'noopener,noreferrer')
}

export default {
  handleOpenGoogleMap,
}
